import { render, staticRenderFns } from "./PaginaTabelleImportiAttivitaBanco.vue?vue&type=template&id=ffd91726&"
import script from "./PaginaTabelleImportiAttivitaBanco.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleImportiAttivitaBanco.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleImportiAttivitaBanco.vue?vue&type=style&index=0&id=ffd91726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports